import { addStyles } from 'ethcss'
import { grid, IStyles, item, mediaCSS } from 'theme'
import { color } from 'theme/tokens/color'

export const styles: IStyles = {
    modalSide: {
        position: 'fixed',
        top: 30,
        bottom: 30,
        backgroundColor: 'white',
        borderRadius: 24,
    },
    'modalSidePosition-right': {
        right: 30,
    },
    'modalSidePosition-left': {
        left: 30,
    },
    modalSideDefaultWidth: {
        width: '30%',
    },
    header: {
        position: 'relative',
        height: 76,
        padding: '24px 76px 24px 32px',
        borderBottom: `1px solid ${color.borderDarkPrimary}`,
        overflow: 'hidden',
    },
    title: {
        fontSize: 24,
        lineHeight: 1,
    },
    closeIcon: {
        position: 'absolute',
        right: 32,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    footer: {
        display: 'flex',
        position: 'absolute',
        justifyContent: 'space-between',
        bottom: 0,
        right: 0,
        left: 0,
        padding: '24px 32px',
        borderTop: `1px solid ${color.borderDarkPrimary}`,
    },
    button: {
        width: '48%',
    },
}

addStyles(styles)
